<template>
    <ModalComponent
        name="crearEntrada"
        :title="'Crear nueva entrada para la sesion: ' + sesion.fecha "
        v-on:close="() => close(false)"
    >

        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormEntrada :entrada="entrada" :sesion="sesion" :recinto="true" :evento_id="evento_id" :butacas="butacas"/>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <Button type="submit" data-cy="crear-entrada" name="button">Crear</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormEntrada from '@/components/backend/eventos/sesiones/FormEntrada';

    export default {
        props: ['sesion', 'evento_id', 'butacas'],
        data() {
            return {
                entrada: {
                    precio: 0,
                    unidades: 0,
                    moneda: this.sesion.moneda
                },
                loading: false
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'crearEntrada', creado);
                this.entrada = {
                    precio: 0,
                    unidades: 0
                };
            },
            crearEntrada() {
                this.loading = true;

                this.entrada.filters = {};
                this.entrada.vouchers = {};

                this.entrada.evento_id = this.evento_id;
                this.entrada.sesion_id = this.sesion.id;

                this.entrada.sale_start = moment(this.entrada.sale_start_zulu).format('YYYY-MM-DD HH:mm:ss');
                this.entrada.sale_stop = moment(this.entrada.sale_stop_zulu).format('YYYY-MM-DD HH:mm:ss');

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.tickets.crear'), this.entrada).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearEntrada();
                }
            },
        },
        components: {
            ModalComponent, FormEntrada
        }
    }
</script>
